import React from 'react';
import Typography from '@material-ui/core/Typography';
import {ReactComponent as MainLogo} from "../../logo.svg"
import Container from "@material-ui/core/Container";
import {Box, Divider} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from '@material-ui/core/styles';
import Footer from "../Footer";

const useStyles = makeStyles((theme) => ({
    main: {
        marginTop: '120px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: '100px'

    }
}));

export default function AuthLayout({children}) {

    const classes = useStyles();
    return (
        <section id={'authLayout'}>
            <Container maxWidth="sm" className={classes.main}>
                <Grid container direction="row"
                      justify="center"
                      alignItems="center">
                    <Grid item>
                        <Typography component="h1" variant="h5" align="center">
                            <a href={'https://www.carwiser.com'} target={'_blank'} rel="noopener noreferrer"><MainLogo/></a>
                            <Divider style={{
                                marginBottom: '16px',
                                marginTop: '16px',
                                marginLeft: '25px',
                                marginRight: '25px',
                            }}/>
                        </Typography>
                    </Grid>

                </Grid>
                <Box className={classes.box}>
                    {children}
                    <Footer/>
                </Box>

            </Container>
        </section>
    );
}